import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDashboardInfo(params) {
	return client.get("binary/dashboard/information-member", {
		params: params,
	});
}

function getSerialCount(params) {
	return client.get("dashboard/serial-count", {
		params: params
	});
}

function getGrowthSummary(params) {
	return client.get("dashboard/member-grow-per-week", {
		params: params,
	});
}

export default {
	getDashboardInfo,
	getSerialCount,
	getGrowthSummary
};